import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { HolidayGroup } from '@classes/holiday/holiday-group';

@Injectable({
  providedIn: 'root'
})
export class HolidayGroupsService {
  holidayGroupsListChanged = new Subject<HolidayGroup[]>();
  private baseUrl: string = environment.apiUrl + 'holiday-groups';
  private holidayGroups: HolidayGroup[];

  constructor(
    private http: HttpClient
  ) { }

  get(): Observable<HolidayGroup[]> {
    return this.http.get<HolidayGroup[]>(this.baseUrl)
      .pipe(
        map(holidayGroups => {
          this.holidayGroups = holidayGroups.map(c => HolidayGroup.fromObject(c));
          this.holidayGroups.sort((a, b) => a.name.localeCompare(b.name));
          this.holidayGroupsListChanged.next([...this.holidayGroups]);
          return [...this.holidayGroups];
        })
      );
  }


  put(holidayGroup: HolidayGroup): Observable<HolidayGroup> {
    return this.http.put<HolidayGroup>(this.baseUrl, holidayGroup)
      .pipe(
        tap(editedHolidayGroup => {
          editedHolidayGroup = HolidayGroup.fromObject(editedHolidayGroup);
          this.holidayGroups = this.holidayGroups.map(c => c.id === editedHolidayGroup.id ? editedHolidayGroup : c);
          this.holidayGroupsListChanged.next([...this.holidayGroups]);
        })
      );
  }

  post(holidayGroup: HolidayGroup): Observable<HolidayGroup> {
    return this.http.post<HolidayGroup>(this.baseUrl, holidayGroup)
      .pipe(
        tap(createdHolidayGroup => {
          createdHolidayGroup = HolidayGroup.fromObject(createdHolidayGroup);
          this.holidayGroups.push(createdHolidayGroup);
          this.holidayGroupsListChanged.next([...this.holidayGroups]);
        })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
        tap(() => {
          this.holidayGroups = this.holidayGroups.filter(c => c.id !== id);
          this.holidayGroupsListChanged.next([...this.holidayGroups]);
        })
      );
  }
}
